import psyImages from "../../components/utility/psychologicalImageImports";
const gardenChoicesRo = [
  {
    label: "O grădină zen cu pietre gri minimaliste și nisip negru.",

    value:
      'A zen garden with minimalist gray stones and black sand.{"Gray":"3","Black":"2"}',
    imageUrl: psyImages["garden/forFormA.jpg"],
  },

  {
    label: "O grădină vibrantă cu flori cu trandafiri roșii și floarea-soarelui galbenă.",
    value:
      'A vibrant flower garden with red roses and yellow sunflowers.{"Red":"3","Yellow":"2"}',
    imageUrl: psyImages["garden/forFormB.jpg"],
  },

  {
    label: "O grădină liniștită cu apă, crini albaștri și iris violet.",
    value:
      'A peaceful garden with water, blue lilies, and purple irises.{"Blue":"3","Violet":"2"}',
    imageUrl: psyImages["garden/forFormC.jpg"],
  },

  {
    label: "O grădină luxuriantă cu legume cu plante verzi și sol pământiu maro.",
    value:
      'A lush vegetable garden with green plants and earthy brown soil.{"Green":"3","Brown":"2"}',
    imageUrl: psyImages["garden/forFormD.jpg"],
  },
];

export default gardenChoicesRo;
